export default "__VITE_ASSET__DyPVDCZP__"